import { render, staticRenderFns } from "./SubmitFormForm.vue?vue&type=template&id=1a259614&scoped=true"
import script from "./SubmitFormForm.vue?vue&type=script&lang=js"
export * from "./SubmitFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a259614",
  null
  
)

export default component.exports